import { render } from "./Edit-Solicitud-Aceptada.vue?vue&type=template&id=0b6c9470&scoped=true"
import script from "./Edit-Solicitud-Aceptada.vue?vue&type=script&lang=js"
export * from "./Edit-Solicitud-Aceptada.vue?vue&type=script&lang=js"

import "./Edit-Solicitud-Aceptada.vue?vue&type=style&index=0&id=0b6c9470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6c9470"]])

export default __exports__